import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { deepGet } from '../../shared/utils'

export default function connectToVersioning(Comp) {

  class VersioningConnectedForm extends Component {

    static propTypes = {
      current: PropTypes.object
    }

    static childContextTypes = {
      dirty: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool
      ]),
      getRejectionMessage: PropTypes.func
    }

    getChildContext() {

      const { current } = this.props

      return {

        dirty: current && !current.version
          ? (current.dirty || {})
          : false,

        getRejectionMessage: (name) => {
          const key = `${current.type}-${deepGet.escapeKey(name)}`
          /* eslint-disable no-underscore-dangle */
          return deepGet(current._message, `${key}.value`, '')
          /* eslint-enable no-underscore-dangle */
        }

      }

    }

    render() {

      return <Comp {...this.props} />
    }

  }

  return VersioningConnectedForm

}



// WEBPACK FOOTER //
// ./src/release/connectors/connectToVersioning.js